module.exports = __webpack_public_path__ + "static/media/about-us3.f5ce3280.png";